import { FC } from 'react';

import { EnecoInHuisLeadFlowsPersonalDetailsStep } from '@eneco/flows/components';
import { usePlaceholderContent } from '@sitecore/common';
import { HeatPumpLeadFlowPersonalDetailsStepRendering } from '@sitecore/types/HeatPumpLeadFlowPersonalDetailsStep';

export const PersonalDetailsStep: FC = () => {
  const { HeatPumpLeadFlowPersonalDetailsStep: { fields: textualData } = {} } = usePlaceholderContent<{
    HeatPumpLeadFlowPersonalDetailsStep: HeatPumpLeadFlowPersonalDetailsStepRendering;
  }>();

  return <EnecoInHuisLeadFlowsPersonalDetailsStep textualData={textualData} />;
};
